export class SceneScheduleDay
{
    constructor(json: any = null)
    {
        if (json)
        {
            Object.assign(this, json);
        }
    }

    public Enabled: boolean;
    public Name: string;
    public ShortName: string;
}
